import { CheckIcon, StarIcon } from "@heroicons/react/24/solid";

import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { AvatarBadge } from "@fronterahealth/frontera-ui-components/ui/avatar";

import { ReportReviewerKind, ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { PersonAvatar } from "@components/QaReview/components/PersonAvatar";
import { getReviewUserDisplay } from "@components/QaReview/components/commentAuthor";
import { Reviewer } from "@components/ReportReview/reviewers";

const STATUS_RING: Record<ReportReviewerStatus, string> = {
  [ReportReviewerStatus.Requested]: "outline-dashed outline-limestone-400",
  [ReportReviewerStatus.Approved]: "outline-green-600",
  [ReportReviewerStatus.ChangesRequested]: "outline-amber-500",
  [ReportReviewerStatus.Withdrawn]: "outline-transparent",
};

const BADGE_SIZE =
  "group-data-[size=default]/avatar:size-3.5 -right-1 group-data-[size=default]/avatar:[&>svg]:size-3.5";

export const ReviewerAvatar: React.FC<{ reviewer: Reviewer; className?: string }> = ({ reviewer, className }) => {
  const { initials } = getReviewUserDisplay(reviewer.reviewer ?? null);
  const { status } = reviewer;

  return (
    <PersonAvatar
      id={reviewer.reviewer?.id ?? reviewer.id}
      initials={initials}
      className={cn("outline-2 outline-offset-2", status && STATUS_RING[status], className)}
    >
      {status === ReportReviewerStatus.Approved && (
        <AvatarBadge className={cn("bg-green-600 text-white -bottom-1.5", BADGE_SIZE)}>
          <CheckIcon />
        </AvatarBadge>
      )}
      {status === ReportReviewerStatus.ChangesRequested && (
        <AvatarBadge className={cn("bg-amber-500 text-xs font-bold text-white -bottom-1.5", BADGE_SIZE)}>!</AvatarBadge>
      )}
      {reviewer.type === ReportReviewerKind.FinalApprover && (
        <AvatarBadge className={cn("bg-limestone-600 text-white", "-top-1.5", BADGE_SIZE)}>
          <StarIcon />
        </AvatarBadge>
      )}
    </PersonAvatar>
  );
};
